/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { useTranslationsMap } from "common/utils/i18n"
import {
  WithMenuHeader,
  WithMenuHeaderInjectedProps,
} from "components/hoc/WithMenuHeader"
import { INVENTORY } from "constants/routes"
import { MenuStoreList } from "pages/menu"
import { menuStoreListHeaderPadding } from "pages/menu/style"
import { useCallback, useEffect } from "react"
import { useHistory } from "react-router"
import { Redirect } from "react-router-dom"
import { OutletStore } from "types/models/menu"
import useSingleStoreUser from "hooks/useSingleStoreUser"
import { TroyWebTracker } from "utils/tracking"
import { EventAction, EventCategory } from "constants/tracking"

export function InventoryList() {
  const history = useHistory()
  const onMenuListRowClick = useCallback(
    (outlet: OutletStore) => {
      history.push(`${INVENTORY}/${outlet.merchantID}`)
    },
    [history],
  )
  return (
    <MenuStoreList
      eventCategory={EventCategory.inventoryHomePage}
      onRowClickOverride={onMenuListRowClick}
    />
  )
}

export function InventoryListWrapped({
  setHeaderTitle,
}: WithMenuHeaderInjectedProps) {
  const textMap = useTranslationsMap({
    pageTitle: "inventory.title",
  })
  const { isSingleStoreUser, storeID } = useSingleStoreUser()

  useEffect(() => {
    TroyWebTracker.sendEvent({
      category: EventCategory.inventoryHomePage,
      action: EventAction.pageView,
    })
  }, [])

  useEffect(() => {
    setHeaderTitle(textMap.pageTitle)
  }, [setHeaderTitle, textMap.pageTitle])
  return (
    <div css={menuStoreListHeaderPadding}>
      {isSingleStoreUser ? (
        <Redirect to={`${INVENTORY}/${storeID}`} />
      ) : (
        <InventoryList />
      )}
    </div>
  )
}

export const InventoryListWithHeader = WithMenuHeader()(InventoryListWrapped)
